module.exports = __webpack_public_path__ + "img/svg/team-photo.f6db621c2a5b0fd861b04b84bfb16d68.svg";